import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex } from 'ui';

type P = {
  icon: ReactNode;
  onClick: () => void;
  title: string;
};

const CreateContentButton = ({ icon, onClick, title }: P) => {
  const { t } = useTranslation();

  return (
    <Button
      block
      className="create-content-button"
      onClick={() => {
        onClick();
      }}
    >
      <Flex align="center" gap="ms" vertical>
        {icon}
        {t(title)}
      </Flex>
    </Button>
  );
};

export default CreateContentButton;
